<template>
	<div data-tour-scope="tags-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.tags') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->

								<!-- <v-divider vertical></v-divider>-->
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi tag" data-tour="add-tag" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getTags"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni tag e' una card; la modifica si apre dai tre puntini -->
								<tbody v-if="mobileCards" class="tag-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="nomeTag(item) || 'Tag'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center">
													<span class="card-label mr-2">Lingue</span>
													<LingueFlags :lingue="item.lingue" />
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-edit" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>{{ nomeTag(item) }}</td>
										<td>{{ item.references }}</td>
										<td>
											{{ item.created_at | moment('DD/MM/YYYY') }}
										</td>
										<td data-tour="langs"><LingueFlags :lingue="item.lingue" /></td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando i tags non potrai più ripristinarli. </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';

Vue.use(VuetifyDraggableTreeview);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import LingueFlags from '@/components/core/LingueFlags.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createTagsListTourSteps, stopTagsListTour } from './tags-list-tour';
import { listRouteState } from '@/components/core/list/listRouteState';

// sotto i 4 caratteri il backend ignora la ricerca
const SEARCH_MIN = 4;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Tag',
	// pagina, righe, ordinamento e ricerca stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createTagsListTourSteps(), { onStop: stopTagsListTour }) };
	},
	data() {
		return {
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			menu: false,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,

			searchfield: '',

			total: 0,

			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Tag', value: 'trans.name' },
				{ text: 'Reference', value: 'references' },
				{ text: 'Created', value: 'created_at' },
				// una bandierina per lingua: a colori dove il nome c'e', in grigio dove manca
				{ text: 'Lingue', value: 'lingue', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				trans: [],
			},

			firstLevel: [],
			secondLevel: [],
			thirdLevel: [],
			fourthLevel: [],
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',

			isMobile: false,

			magento: false,
			langDefault: '',
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			languages: [],
		};
	},
	/*created () {
      this.setDialog(false)
      this.initialize();

  },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return (value = value.toFixed(2));
		},
	},
	async mounted() {
		this.setExistFilter(true);
		this.listLoad();
		//
		// if(this.getTags.length == 0){
		//   await this.getDataFromApi()
		// }

		this.fetchSetting().then(data => {
			var list = JSON.parse(JSON.stringify(this.getSettings.languages));

			var defaultLang = _.find(list, { default: true });

			this.langDefault = defaultLang.lang;
			list = _.orderBy(list, ['default'], ['desc']);
			this.languages = _.filter(list, { is_active: true });

			this.languages.map(lang => {
				this.messages.trans.push({
					lang: lang.lang,
					name: '',
				});
			});
		});
	},
	watch: {
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		LingueFlags,
		KeyValueCard,
		TourOverlay,

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'categories/getIndex',
			getTags: 'tags/getTags',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'tags/getSortBy',
			getSortDesc: 'tags/getSortDesc',

			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function (old, newvalue) {
				return this.clippedOrder;
			},
			set: function (newvalue) {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		nomeTag(item) {
			const trans = _.find(item.trans, { lang: this.langDefault });
			return trans ? trans.name : '';
		},
		// stessi dati delle colonne Reference/Created della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Reference', value: item.references },
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setTags: 'tags/setTags',
			setTag: 'tags/setTag',
			setIndex: 'tags/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'tags/asyncFetchData',

			destroyData: 'tags/destroyData',
			saveData: 'users/saveData',

			setUpdateStatusCategory: 'categories/setUpdateStatusCategory',
			deleteTags: 'tags/deleteTags',
			fetchSetting: 'settings/asyncFetchData',
			updateData: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),
		filterCheck(event) {
			var dot = _.map(event, 'id');

			this.settings.filters.categories = dot;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggleDrawerSort() {
			this.setDrawerFilter(0);
			this.clippedOrder = !this.clippedOrder;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		changeStatus(item) {
			try {
				this.setPreload(true);
				this.isActive = true;

				let items = this.setUpdateStatusCategory({ id: item.id, is_active: item.is_active }).then(result => {
					//this.total = result.total
					//this.items = result.data.data
					if (result.data.data.ok) {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
					this.setPreload(false);
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async getCategoryMagento() {
			this.setPreload(true);
			await this.getFetchCategoryMagento();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'I tags verranno caricate in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		// inserimento e modifica sono pagine (si apre solo dalla riga, tre puntini):
		// la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/tags/${item._id}`);
		},
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/tags/new');
		},
		// ritorna la promessa: chi elimina aspetta il ricaricamento prima del messaggio
		getDataFromApi() {
			this.setPreload(true);
			this.isActive = true;
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result.total;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.setPreload(false);
				});
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {},

		deleteItem(item = null) {
			this.dialogconfirm = true;

			if (item) {
				this.form = item;
			}
		},
		confirmDelete() {
			this.dialogconfirm = false;
			// solo il tag scelto dai tre puntini: niente piu' eliminazione multipla
			const paypload = this.form && this.form._id ? _.filter(this.getTags, { _id: this.form._id }) : [];
			this.deleteTags(paypload)
				.then(data => {
					this.setPreload(false);

					this.getDataFromApi().then(res => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style>
/*.v-data-table

tr:hover:not(.v-data-table__expanded__content) {
    background: #ffffff !important;
}
tr.active:hover:not(.v-data-table__expanded__content) {
    background: #F5F5F5 !important;
}*/
</style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.tag-cards,
.tag-cards tr {
	display: block;
	width: 100%;
}
.tag-cards tr,
.tag-cards tr:hover {
	background: transparent !important;
}
.tag-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.tag-cards tr:first-child td {
	padding-top: 12px !important;
}
.tag-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.tag-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
